import React from 'react';
import classNames from 'clsx';
import InformationOutline from 'mdi-material-ui/InformationOutline';
import {
  Color,
  Alert as MuiAlert,
  AlertTitle as MuiAlertTitle,
} from '@material-ui/lab';

import { getTextWithoutEscape } from 'app/shared/helpers/getTextWithoutEscape';
import { MessageTypeEnum } from 'app/shared/enums';
import { useStyles } from './Alert.styles';
import { AlertProps } from './Alert.interfaces';

const severityConfig = {
  [MessageTypeEnum.Advisory]: 'warning',
  [MessageTypeEnum.Danger]: 'error',
  [MessageTypeEnum.Info]: 'info',
  [MessageTypeEnum.Success]: 'success',
  [MessageTypeEnum.Warning]: 'warning',
  [MessageTypeEnum.BulbInfo]: 'warning',
};

export default function Alert(props: AlertProps) {
  const classes = useStyles();

  const {
    children,
    className,
    icon,
    type,
    title,
    text,
    dataCy = 'alert',
  } = props;

  return (
    <MuiAlert
      icon={icon}
      iconMapping={{
        warning: <InformationOutline />,
      }}
      severity={severityConfig[type] as Color}
      className={classNames(classes.root, className, {
        [classes.advisory]: type === MessageTypeEnum.Advisory,
      })}
      classes={{
        standardError: classes.error,
        standardInfo: classes.info,
        standardWarning: classes.warning,
        standardSuccess: classes.success,
        icon: classes.icon,
        message: classes.message,
      }}
      data-cy={dataCy}
    >
      {title && (
        <MuiAlertTitle className={classes.title}>{title}</MuiAlertTitle>
      )}
      {children}
      {text && getTextWithoutEscape(text)}
    </MuiAlert>
  );
}
